/* eslint-disable import/no-unresolved */
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { onChangeIndianCurrency } from "src/helpers/FormDetails";
import CustomLabel from "../../../../../shared/CustomLabel";
import CustomReviewField from "../../../../../shared/CustomReviewField";

function MorePolicyDetails() {
  const jointLifeDetails = useAppSelector((state) => state.jointLifeAddendum);
  return (
    <div>
      <div className="flex justify-start mt-10">
        <p className="text-base ">
          Details of existing life / critical illness / credit life cover details OR pending /
          simultaneous insurance cover for fresh / lapsed policies OR / any declined / postponed /
          rated up / null & void / not taken up on life assured / joint life in the below table.
        </p>
      </div>
      <div>
        {jointLifeDetails?.existingPolicy?.existingPolicyDetails?.map(
          (existingPolicyDetails, index) => (
            <div>
              {index > 0 && <hr className="mt-6" />}
              <div className="grid grid-flow-row-dense lg:grid-cols-3 grid-cols-2 gap-y-8 lg:gap-x-32 md:gap-x-36 gap-x-3 mt-6 max-sm:ml-4 ">
                <div className="col-span-1">
                  <CustomLabel>Policy / Application Number</CustomLabel>
                  <CustomReviewField>
                    {existingPolicyDetails?.policyNumber || "-"}
                  </CustomReviewField>
                </div>
                <div className="col-span-1">
                  <CustomLabel>Total Sum Assured (in Rs)</CustomLabel>
                  <CustomReviewField>
                    {onChangeIndianCurrency(existingPolicyDetails?.totalSumInsured || "-")}
                  </CustomReviewField>
                </div>
                <div className="col-span-1">
                  <CustomLabel>Name of Insurance Company</CustomLabel>
                  <CustomReviewField>
                    {existingPolicyDetails?.nameOfInsuranceCompany || "-"}
                  </CustomReviewField>
                </div>
                <div className="col-span-1">
                  <CustomLabel>Acceptance Terms</CustomLabel>
                  <CustomReviewField>
                    {existingPolicyDetails?.acceptanceTerms || "-"}
                  </CustomReviewField>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
}
export default MorePolicyDetails;
